module.exports = __webpack_public_path__ + "static/media/DatePickerLeft.f5371770.svg";